import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { startedAt: String }

  connect() {
    this.started = Date.parse(this.startedAtValue)
    if (Number.isNaN(this.started)) return

    this.render()
    this.timer = setInterval(() => this.render(), 1000)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  render() {
    const total = Math.max(0, Math.floor((Date.now() - this.started) / 1000))
    const parts = [Math.floor(total / 3600), Math.floor((total % 3600) / 60), total % 60]
    this.element.textContent = parts.map((part) => String(part).padStart(2, "0")).join(":")
  }
}
